import {makeRequest} from "./httpRequest";
import Config from "../core/config";
import {formatDateToAmericanFormat} from "./utils";
import {getAuthHeader} from "./auth";
import {saveAs} from 'file-saver';
const apiUrl = Config.apiUrl;

export async function findProductsByQueryString(query) {
    try {
        const url = apiUrl + '/api/products/query=' + (query && query !== '' ? query : '');
        const response = await makeRequest(url, 'GET');
        return response;
    } catch (error) {
        console.error('Error fetching data:', error);
    }
}

export async function getProductById(id) {
    try {
        const url = apiUrl + '/api/products/id=' + id;
        return await makeRequest(url, 'GET');
    } catch (error) {
        console.error('Error fetching data:', error);
    }
}

export async function createProduct(productData) {
    try {
        const url = apiUrl + '/api/products';
        return await makeRequest(url, 'POST', {
            'Content-Type': 'application/json',
        }, JSON.stringify(productData));
    } catch (error) {
        console.error('Error creating product:', error);
        throw error;
    }
}

export async function updateAutomotiveServiceStatus(id, status) {
    try {
        const url = apiUrl + '/api/automotiveservices/' + id + '/status';
        return await makeRequest(url, 'PATCH', {
            'Content-Type': 'application/json',
        }, status);
    } catch (error) {
        console.error('Error updating automotive service status:', error);
        throw error;
    }
}

export async function getProductRentalPriceByProductId(productId) {
    try {
        const url = apiUrl + '/api/product_rental_prices/productId=' + productId;
        return await makeRequest(url, 'GET');
    } catch (error) {
        console.error('Error fetching data:', error);
    }
}

export function getProductAvailability(productId, rentalIds, days) {
    const url = `${apiUrl}/api/productAvailabilities/productId=${productId ? productId : 0}&rentalIds=${rentalIds}&days=${days}&currentDate=${formatDateToAmericanFormat(new Date())}`;
    return makeRequest(url, 'GET');
}

export function getProductUnavailability(productId) {
    const url = `${apiUrl}/api/productAvailabilities/unavailability/productId=${productId ? productId : 0}`;
    return makeRequest(url, 'GET');
}

export async function getProductAvailabilityFilterByQuantity(productId, rentalIds, currentDate, days, quantity) {
    const url = `${apiUrl}/api/productAvailabilities/productId=${productId ? productId : 0}&rentalIds=${rentalIds}&days=${days}&currentDate=${formatDateToAmericanFormat(currentDate)}`;
    const availabilities = await makeRequest(url, 'GET');
    return availabilities.filter((a) => a.quantity >= quantity)
}

export function getProductAvailabilityPerDate(productId, rentalIds, days, currentDate, startDate, endDate, quantity) {
    const url = `${apiUrl}/api/productAvailabilities/filterByDate/productId=${productId ? productId : 0}&rentalIds=${rentalIds}&days=${days}&currentDate=${formatDateToAmericanFormat(currentDate)}&startDate=${formatDateToAmericanFormat(startDate)}&endDate=${formatDateToAmericanFormat(endDate)}&quantity=${quantity}`;
    return makeRequest(url, 'GET');
}

export async function findCustomersByQueryString(query) {
    try {
        const url = apiUrl + '/api/customers/query=' + (query && query !== '' ? (query) : '');
        const response = await makeRequest(url, 'GET');
        return response;
    } catch (error) {
        console.error('Error fetching data:', error);
    }
}

export async function getCustomerById(id) {
    try {
        const url = apiUrl + '/api/customers/id=' + id;
        return await makeRequest(url, 'GET');
    } catch (error) {
        console.error('Error fetching data:', error);
    }
}

export async function getPaymentById(id) {
    try {
        const url = apiUrl + '/api/payments/id=' + id;
        return await makeRequest(url, 'GET');
    } catch (error) {
        console.error('Error fetching data:', error);
    }
}

export async function getAllPaymentMethods() {

    try {
        const url = apiUrl + '/api/paymentMethods';
        const response = await makeRequest(url, 'GET');
        return response;
    } catch (error) {
        console.error('Error fetching data:', error);
    }

}

export async function getAllPaymentMethodsMercadoPago() {
    try {
        const url = apiUrl + '/api/paymentMethodsMercadoPago';
        const response = await makeRequest(url, 'GET');
        return response;
    } catch (error) {
        console.error('Error fetching data:', error);
    }
}

export async function customerKeyExists(customerKey) {
    const url = apiUrl + '/api/customerKey/customerKey=' + customerKey;
    return makeRequest(url, 'GET');
}

export async function isSpaceBorneDelivery(customerKey) {
    const url = apiUrl + '/api/customerKey/isSpaceBorneDelivery/customerKey=' + customerKey;
    return makeRequest(url, 'GET');
}

export async function getSaleById(id) {

    try {
        const url = apiUrl + '/api/sales/id=' + id;
        return await makeRequest(url, 'GET');
    } catch (error) {
        console.error('Error fetching data:', error);
    }

}

export async function getCompanyOfCurrentUser() {

    try {
        const url = apiUrl + '/api/companies/current';
        return await makeRequest(url, 'GET');
    } catch (error) {
        console.error('Error fetching data:', error);
    }

}

export async function downloadContract(id, code) {
    try {
        const url = `${apiUrl}/api/contract/${id}`;
        const response = await fetch(url, {headers: {...getAuthHeader()}});
        const data = await response.blob();

        saveAs(data, 'contrato_' + code + '.pdf');

    } catch (error) {
        console.error('Erro ao obter PDF:', error);
    }
}

export async function downloadDeliveryStatement(id, code) {
    try {
        const url = `${apiUrl}/api/deliveryStatement?id=${id}`;
        const response = await fetch(url, {headers: {...getAuthHeader()}});
        const data = await response.blob();

        saveAs(data, 'termo_de_entrega_' + code + '.pdf');

    } catch (error) {
        console.error('Erro ao obter PDF:', error);
    }
}

export async function downloadDeliveryStatementByDate(id, code, date) {
    try {
        const url = `${apiUrl}/api/deliveryStatement?id=${id}&date=${formatDateToAmericanFormat(date)}`;
        const response = await fetch(url, {headers: {...getAuthHeader()}});
        const data = await response.blob();
        saveAs(data, `termo_de_entrega_${code}.pdf`);
    } catch (error) {
        console.error('Erro ao obter PDF:', error);
    }
}

export async function findSectorsByQueryString(query) {
    try {
        // const sectorInLocalStorageJson = localStorage.getItem('sectors');
        // if(sectorInLocalStorageJson !== undefined) {
        //     const sectorsInLocalStorage = JSON.parse(sectorInLocalStorageJson);
        //     if (sectorsInLocalStorage !== undefined && sectorsInLocalStorage !== null && sectorsInLocalStorage.length > 0) {
        //         return sectorsInLocalStorage;
        //     }
        // }
        const url = apiUrl + '/api/sectors/query=' + (query && query !== '' ? (query) : '');
        const response = await makeRequest(url, 'GET');
        localStorage.setItem('sectors', JSON.stringify(response));
        return response;
    } catch (error) {
        console.error('Error fetching data:', error);
    }
}

export async function findSuppliersByQueryString(query) {
    try {
        const url = apiUrl + '/api/suppliers/query=' + (query && query !== '' ? (query) : '');
        const response = await makeRequest(url, 'GET');
        return response;
    } catch (error) {
        console.error('Error fetching data:', error);
    }
}

export async function getSupplierById(id) {
    try {
        const url = apiUrl + '/api/suppliers/id=' + id;
        return await makeRequest(url, 'GET');
    } catch (error) {
        console.error('Error fetching data:', error);
    }
}

export async function findPaymentTermsByQueryString(query) {
    try {
        // const sectorInLocalStorageJson = localStorage.getItem('sectors');
        // if(sectorInLocalStorageJson !== undefined) {
        //     const sectorsInLocalStorage = JSON.parse(sectorInLocalStorageJson);
        //     if (sectorsInLocalStorage !== undefined && sectorsInLocalStorage !== null && sectorsInLocalStorage.length > 0) {
        //         return sectorsInLocalStorage;
        //     }
        // }
        const url = apiUrl + '/api/payment_terms/query=' + (query && query !== '' ? (query) : '');
        const response = await makeRequest(url, 'GET');
        localStorage.setItem('sectors', JSON.stringify(response));
        return response;
    } catch (error) {
        console.error('Error fetching data:', error);
    }
}

export async function findUsersByQueryString(query) {
    try {
        const url = apiUrl + '/api/users/query=' + (query && query !== '' ? (query) : '');
        const response = await makeRequest(url, 'GET');
        localStorage.setItem('users', JSON.stringify(response));
        return response;
    } catch (error) {
        console.error('Error fetching data:', error);
    }
}

export async function findUsersByCompanyIdAndQueryString(query) {
    try {
        const url = apiUrl + '/api/users/company/query=' + (query && query !== '' ? (query) : '');
        const response = await makeRequest(url, 'GET');
        localStorage.setItem('users', JSON.stringify(response));
        return response;
    } catch (error) {
        console.error('Error fetching data:', error);
    }
}

export async function getCompanyClosedConfiguration() {
    try {
        const url = `${apiUrl}/api/companyClosedDays`;
        return await makeRequest(url, 'GET');
    } catch (error) {
        console.error('Error fetching company closed days:', error);
        throw error;
    }
}

export async function saveCompanyClosedConfiguration(payload) {
    try {
        const url = `${apiUrl}/api/companyClosedDays`;
        return await makeRequest(url, 'PUT', {
            'Content-Type': 'application/json',
        }, JSON.stringify(payload));
    } catch (error) {
        console.error('Error saving company closed configuration:', error);
        throw error;
    }
}

export async function findByDateAndStatus(startDate, endDate, status = 'OPENING',) {
    try {
        const url = new URL(apiUrl + '/api/sales/queryByDateAndStatus');

        const params = {
            startDate: startDate.toISOString(),
            endDate: endDate.toISOString(),
            status: status
        };

        Object.keys(params).forEach(key => url.searchParams.append(key, params[key]));

        // const url = apiUrl + '/api/sales/query=' + (query && query !== '' ? (query) : '');
        const response = await makeRequest(url, 'GET');
        localStorage.setItem('sales', JSON.stringify(response));
        return response;
    } catch (error) {
        console.error('Error fetching data:', error);
    }
}

export async function getReceivableById(id) {

    try {
        const url = apiUrl + '/api/receivables/id=' + id;
        return await makeRequest(url, 'GET');
    } catch (error) {
        console.error('Error fetching data:', error);
    }

}

export const downloadSaleFile = async (saleId, filename) => {
    try {
        const response = await fetch(`${apiUrl}/api/sales/${saleId}/file/${filename}`, {
            method: 'GET',
            headers: {
                ...getAuthHeader(),
            },
        });

        if (!response.ok) {
            throw new Error('Erro ao baixar o arquivo. Status: ' + response.status);
        }

        const blob = await response.blob();

        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;

        const contentDisposition = response.headers.get('Content-Disposition');
        const fileName = contentDisposition ? contentDisposition.split('filename=')[1].replace(/"/g, '') : filename;

        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();

        link.parentNode.removeChild(link);
    } catch (error) {
        console.error('Erro ao baixar o arquivo:', error);
        alert('Erro ao baixar o arquivo. Tente novamente.');
    }
};


export async function updateSaleStatus(id, status) {
    try {
        const url = `${apiUrl}/api/sales/${id}/status`;
        return JSON.stringify(await makeRequest(url, 'PATCH', {
            'Content-Type': 'application/json',
        }, JSON.stringify(status)));
    } catch (error) {
        console.error('Error fetching data:', error);
    }


}

export async function userHasPermission(permission) {
    try {
        const url = apiUrl + '/api/userpermission/check?permission=' + permission;
        const response = await makeRequest(url, 'GET');
        return response.hasPermission;
    } catch (error) {
        console.error('Error fetching data:', error);
        return false;
    }
}

export async function findCompaniesByQueryString(query) {
    try {
        const url = apiUrl + '/api/companies/query=' + (query && query !== '' ? (query) : '');
        return await makeRequest(url, 'GET');
    } catch (error) {
        console.error('Error fetching data:', error);
    }
}

export async function findPendingReceivablesByCustomerCompanyId() {
    try {
        const url = apiUrl + '/api/receivables/pendingReceivablesCustomerCompany';
        return await makeRequest(url, 'GET');
    } catch (error) {
        console.error('Error fetching data:', error);
    }
}

export async function getCompanyById(id) {

    try {
        const url = apiUrl + '/api/companies/id=' + id;
        return await makeRequest(url, 'GET');
    } catch (error) {
        console.error('Error fetching data:', error);
    }

}

export async function isUserAdmin(){
    const url = `${apiUrl}/api/users/check_admin_user`;
    const response1 = await makeRequest(url, 'GET');

    return response1.isAdmin;

}

export async function getRentalById(id) {
    try {
        const url = apiUrl + '/api/rentals/id=' + id;
        return await makeRequest(url, 'GET');
    } catch (error) {
        console.error('Error fetching data:', error);
    }
}

export async function getSalesChartData(startDate, endDate) {
    try {
        const url = `${apiUrl}/api/dashboards/sales-chart-data-by-month?startDate=${formatDateToAmericanFormat(startDate)}&endDate=${formatDateToAmericanFormat(endDate)}`;
        const response = await makeRequest(url, 'GET');
        return response;
    } catch (error) {
        console.error('Error fetching data:', error);
    }
}

export async function getCustomersChartData(startDate, endDate) {
    try {
        const url = `${apiUrl}/api/dashboards/customers-chart-data-by-month?startDate=${formatDateToAmericanFormat(startDate)}&endDate=${formatDateToAmericanFormat(endDate)}`;
        const response = await makeRequest(url, 'GET');
        return response;
    } catch (error) {
        console.error('Error fetching data:', error);
    }
}

export async function getAverageTicketChartData(startDate, endDate) {
    try {
        const url = `${apiUrl}/api/dashboards/average-ticket-chart-data-by-month?startDate=${formatDateToAmericanFormat(startDate)}&endDate=${formatDateToAmericanFormat(endDate)}`;
        const response = await makeRequest(url, 'GET');
        return response;
    } catch (error) {
        console.error('Error fetching data:', error);
    }
}

export async function getAverageCustomerAgeChartData(startDate, endDate) {
    try {
        const url = `${apiUrl}/api/dashboards/average-customer-age-chart-data-by-month?startDate=${formatDateToAmericanFormat(startDate)}&endDate=${formatDateToAmericanFormat(endDate)}`;
        const response = await makeRequest(url, 'GET');
        return response;
    } catch (error) {
        console.error('Error fetching data:', error);
    }
}

// Company Group Permissions API (admin only)
export async function fetchCompanyGroups() {
    const response = await makeRequest(Config.apiUrl + '/api/company-group-permissions', 'GET');
    return response;
}

export async function createCompanyGroup(group) {
    const response = await makeRequest(Config.apiUrl + '/api/company-group-permissions', 'POST', {
        'Content-Type': 'application/json',
    }, JSON.stringify(group));
    return response;
}

export async function updateCompanyGroup(id, group) {
    const response = await makeRequest(Config.apiUrl + `/api/company-group-permissions/${id}`, 'PUT', {
        'Content-Type': 'application/json',
    }, JSON.stringify(group));
    return response;
}

export async function deleteCompanyGroup(id) {
    const response = await makeRequest(Config.apiUrl + `/api/company-group-permissions/${id}`, 'DELETE');
    return response;
}

export async function getCompanyGroupById(id) {
    const response = await makeRequest(Config.apiUrl + `/api/company-group-permissions/${id}`, 'GET');
    return response;
}

export async function getCustomerAgeRangeReport(minAge, maxAge, ageRange) {
    try {
        let url = `${apiUrl}/api/customerAgeRangeReport`;
        const params = new URLSearchParams();
        
        if (minAge !== undefined && minAge !== null) {
            params.append('minAge', minAge);
        }
        if (maxAge !== undefined && maxAge !== null) {
            params.append('maxAge', maxAge);
        }
        if (ageRange !== undefined && ageRange !== null && ageRange !== '') {
            params.append('ageRange', ageRange);
        }
        
        if (params.toString()) {
            url += '?' + params.toString();
        }
        
        const response = await makeRequest(url, 'GET');
        return response;
    } catch (error) {
        console.error('Error fetching customer age range report:', error);
        return [];
    }
}

export async function getAvailableAgeRanges() {
    try {
        const url = `${apiUrl}/api/customerAgeRangeReport/ageRanges`;
        const response = await makeRequest(url, 'GET');
        return response;
    } catch (error) {
        console.error('Error fetching available age ranges:', error);
        return [];
    }
}
